import React from "react";
import { ClearAllProps } from "@usereactify/search";

export type ClearAllButtonProps = React.ComponentProps<NonNullable<ClearAllProps["render"]>>;

export const ClearAllButton: React.FC<ClearAllButtonProps> = (props) => {
  return (
    <button
      onClick={() => props.clearAll()}
      className="product-facet__collection-filters__clear-all mid-dark-grey-text"
    >
      {"Clear All"}
    </button>
  );
};
